// extracted by mini-css-extract-plugin
module.exports = {"toggle_icon":"header-login-form_toggle_icon_iT3Mr"};